import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Login as LoginIcon, Rocket } from 'shared/icons';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { useAuth } from '../hooks/useAuth';

function normalizeNextPath(rawValue) {
    const normalized = String(rawValue || '').trim();
    if (!normalized) {
        return '/';
    }

    if (!normalized.startsWith('/')) {
        return '/';
    }

    if (normalized.startsWith('//') || normalized.toLowerCase().startsWith('/login')) {
        return '/';
    }

    return normalized;
}

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const nextPath = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return normalizeNextPath(params.get('next'));
    }, [location.search]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate(nextPath, { replace: true });
        } catch (err) {
            setError(err.message || 'Erro ao fazer login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-mono-100 dark:bg-mono-950">
            <div className="w-full max-w-md">
                {/* Card de Login */}
                <div className="bg-white dark:bg-black rounded-2xl shadow-xl p-8 border border-mono-200 dark:border-mono-900">
                    {/* Header */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 mb-6">
                            <Rocket size={48} weight="bold" className="text-black dark:text-white" />
                        </div>
                        <h1 className="text-3xl font-bold text-black dark:text-white mb-2">Melidash</h1>
                        <p className="text-mono-600 dark:text-mono-400">Area Restrita</p>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <Input
                            id="login-email"
                            label="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="seu@email.com"
                            autoComplete="email"
                        />

                        <Input
                            id="login-password"
                            label="Senha"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder=""
                            autoComplete="current-password"
                        />

                        {error && (
                            <div className="p-3 bg-mono-100 dark:bg-mono-900 border border-mono-300 dark:border-mono-700 rounded-lg">
                                <p className="text-sm text-mono-800 dark:text-mono-300">{error}</p>
                            </div>
                        )}

                        <Button type="submit" loading={loading} className="w-full flex items-center justify-center">
                            <LoginIcon size={20} className="mr-2" />
                            Entrar
                        </Button>
                    </form>
                </div>

                {/* Footer */}
                <p className="text-center mt-6 text-sm text-mono-500 dark:text-mono-600">
                    2026 · Todos os direitos reservados
                </p>
            </div>
        </div>
    );
};

export default Login;
